import styled from "styled-components";

export const Label = styled.label`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${(props: { error: boolean }) => (props.error ? "red" : "#636c79")};
  margin-bottom: 16px;
`;

export const Input = styled.input`
  background: #f1f4fb;
  border-radius: 2px;
  outline: none;
  height: 42px;
  width: 300px;
  margin-bottom: 24px;
  padding-left: 16px;
  font-weight: 500;
  font-size: 16px;
  border: ${(props: { error: boolean }) =>
    props.error ? "1px solid red" : "1px solid rgba(241, 244, 251, 1)"};
  ::placeholder {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #8a919c;
  }
`;

export const ChipInputRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputBoxWithChip = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background: #f1f4fb;
  border: ${(props: { error: boolean }) =>
    props.error ? "1px solid red" : "1px solid rgba(241, 244, 251, 1)"};
  border-radius: 2px;
  min-height: 42px;
  height: auto;
  margin-bottom: 24px;
  padding-left: 16px;
  row-gap: 0.5em;
`;

export const InputForChip = styled.input`
  display: inline-block;
  width: auto;
  outline: none;
  border: none;
  background: #f1f4fb;
  font-weight: 500;
  ::placeholder {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #8a919c;
  }
`;

export const TextAreaRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
`;

export const TextBox = styled.textarea`
  width: 100%;
  display: block;
  background: #f1f4fb;
  border-radius: 2px;
  outline: none;
  padding-left: 16px;
  padding-top: 10px;
  font-weight: 500;
  border: ${(props: { error: boolean }) =>
    props.error ? "1px solid red" : "1px solid rgba(241, 244, 251, 1)"};
  resize: none;
  height: 120px;
  ::placeholder {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #8a919c;
  }
`;

export const ErrorText = styled.p`
  color: red;
  font-size: 12px;
  padding-left: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
`;

export const ErrorInputText = styled(ErrorText)`
  margin-top: -20px;
`;

// oocyte dropdown
export const InputBoxDropdown = styled.div`
  display: flex;
  background: #f1f4fb;
  border-radius: 2px;
  outline: none;
  padding-left: 16px;
  min-height: 42px;
  padding-top: 8px;
  cursor: pointer;
  position: relative;
`;

export const InputBoxDropdownSectionOne = styled.div`
  width: 90%;
`;

export const PlaceholderText = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #8a919c;
`;

export const CheckboxLabel = styled.label`
  font-family: Poppins;
  font-style: medium;
  font-size: 16px;
  line-height: 24px;
  color: #636c79;
`;

export const ChipGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 0.5em;
  padding-top: 4px;
`;

export const InputBoxDropdownSectionTwo = styled.div`
  width: 10%;
  text-align: center;
`;

export const DropdownList = styled.div`
  position: absolute;
  bottom: -100px;
  left: 0;
  width: 100%;
  border: 1px solid rgba(138, 145, 156, 0.3);
  background: rgba(255, 255, 255, 1);
`;

export const MyCheckbox = styled.input`
  transform: scale(1.4);
  border: 1px solid red !important;
  margin-right: 10px;
  margin-left: 10px;
`;
